import request from '@/utils/request'
import qs from 'qs'

export const getToken = (loginForm) =>
  request({
    url: '/auth/token',
    method: 'post',
    data: loginForm
  })



// WEBPACK FOOTER //
// ./src/api/admin/auth.js